// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"72c7a5ca","488":"ec68fac5"}[chunkId] + ".chunk.js";
};